import React from "react";
import moment from "moment";

import Config from "@skin_config";
import HighlightText from "@common/components/highlighText";
import { nthNumber } from "@common/helpers/nthNumber";

export const RESULT_PAGE_ITEM_COUNT = 16;
export const OTHER_ROWS = 3;

export const ROW_HEIGHT = 57;

const getScoreItemValue = (scoreItem) => {
  const [a, b, ...rest] = scoreItem.split(" ");

  return rest.join(" ");
};

const virtuaslWinnersColors = ["#1BB774", "#FFC33E", "#0C8CE9"];

export const resultTableColumnConfigs = (t, searchText, sportId) => {
  const winInfoColumns = Config.main.resultPageVirtualsId.includes(sportId)
    ? [
        {
          name: "Winners",
          columnClassName: "type-winners",
          rowClassName: "type-winners",
          row: (item) => {
            const { scores } = item;
            const scoresList = scores.split(" , ");

            return (
              <div className="virtuals-result-wrapper">
                {scoresList.map((scoreItem, ind) => (
                  <div className="score-item" key={ind}>
                    <span className="dot" style={{ backgroundColor: virtuaslWinnersColors[ind] }}></span>
                    <span>{nthNumber(ind + 1)}</span>
                    <span className="name">{getScoreItemValue(scoreItem)}</span>
                  </div>
                ))}
              </div>
            );
          },
        },
      ]
    : [
        {
          name: "Team 1",
          columnClassName: "type-team1",
          rowClassName: "result-table-team1-name",
          row: (item) => <HighlightText text={item.team1_name} highlightPart={searchText} />,
        },
        {
          name: "score",
          columnClassName: "type-score",
          rowClassName: "type-score",
          row: (item) => {
            const matchedScores = (item.scores || "").match(/(\w+(\.\d+)?\s*:\s*\w+(\.\d+)?)/g);
            const [firstScore, secondScore] = matchedScores?.[0].split(":") || [];

            return (
              <div className={`result-score ${item.sport_alias === "VirtualDragRacing" && "drag-racing"}`}>
                <div className="result-score-number-wrp">
                  {" "}
                  <span className="result-score-number">{firstScore}</span>{" "}
                </div>
                <div className="result-score-number-wrp">
                  {" "}
                  <span className="result-score-number">{secondScore}</span>{" "}
                </div>
              </div>
            );
          },
        },
        {
          name: "Team 2",
          columnClassName: "type-team2",
          rowClassName: "result-table-team2-name",
          row: (item) => <HighlightText text={item.team2_name} highlightPart={searchText} />,
        },
      ];

  return [
    {
      name: "Id",
      columnClassName: "type-id",
      rowClassName: "type-id",
      row: (item) => item.game_id,
    },
    ...winInfoColumns,
    {
      name: "Competition",
      row: (item) => item.competition_name,
    },
    {
      name: "Region",
      row: (item) => item.region_name,
    },
    {
      name: "DATE",
      row: (item) => moment.unix(item.date).format(Config.main.dateTimeFormat),
    },
  ];
};
